module.exports = __webpack_public_path__ + "odinstatic/v13.0.1/media/operations.c87f648f.svg";